var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 11.1383H9.67499V5.82577C9.67499 3.62108 8.0453 1.7992 5.92499 1.49608V0.888268C5.92499 0.542955 5.6453 0.263268 5.29999 0.263268C4.95468 0.263268 4.67499 0.542955 4.67499 0.888268V1.49608C2.55468 1.7992 0.924988 3.62108 0.924988 5.82577V11.1383H0.549988C0.273425 11.1383 0.0499878 11.3617 0.0499878 11.6383V12.1383C0.0499878 12.207 0.106238 12.2633 0.174988 12.2633H3.54999C3.54999 13.2289 4.33436 14.0133 5.29999 14.0133C6.26561 14.0133 7.04999 13.2289 7.04999 12.2633H10.425C10.4937 12.2633 10.55 12.207 10.55 12.1383V11.6383C10.55 11.3617 10.3266 11.1383 10.05 11.1383ZM5.29999 13.0133C4.88593 13.0133 4.54999 12.6773 4.54999 12.2633H6.04999C6.04999 12.6773 5.71405 13.0133 5.29999 13.0133ZM2.04999 11.1383V5.82577C2.04999 4.95702 2.38749 4.14139 3.00155 3.52733C3.61561 2.91327 4.43124 2.57577 5.29999 2.57577C6.16874 2.57577 6.98436 2.91327 7.59843 3.52733C8.21249 4.14139 8.54999 4.95702 8.54999 5.82577V11.1383H2.04999Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlarmIcon);
export default __webpack_public_path__ + "static/media/warningAlarmIcon.fddb4193c6d0fc967f8687d91ac30324.svg";
export { ForwardRef as ReactComponent };